import { render, staticRenderFns } from "./BillDetailReturnDetail.vue?vue&type=template&id=4f070746&scoped=true"
import script from "./BillDetailReturnDetail.vue?vue&type=script&lang=ts"
export * from "./BillDetailReturnDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f070746",
  null
  
)

export default component.exports